// main
import MCHCHAN from '@/api/module/mchchan.js';
const main = {
  namespaced: true,
  state: {
    collapse: false,
    checkdApplyName: '',
    merchantInfo:{}   //主商户详情
   },
  mutations: {
    updateCollapse(state) {
      state.collapse = !state.collapse;
    },
    setcheckdApplyName(state, data) {
      state.checkdApplyName = data.applyName;
    },
    // 汇付宝应用获取主商户信息
    merchantInfo(state, data) {
      state.merchantInfo = data;
      localStorage.setItem('merchantInfo', JSON.stringify(state.merchantInfo));
    },
  },
  actions: {
    //获取主商户信息
    async getMerchantInfo({ commit }, params) {
      try {
        const result = await MCHCHAN.getMerchantInfo(params);
        commit('merchantInfo', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    checkdApplyName: state => state.checkdApplyName,
  },
};
export default main;
